// removed by extract-text-webpack-plugin
module.exports = {"table":"_2YrjKdFd-Xu9i7dNywhLsM"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardList.scss
// module id = 13614
// module chunks = 0